export const DefaultJourneyValue = 'action';
export const DefaultActionValue = 'clicked';

export interface SystemEventData {
  event?: string;
  source?: Source;
  metadata?: Record<string, unknown>;
}

export interface Source {
  module?: string;
  location?: string;
}

export interface TrackEventData extends SystemEventData {
  module?: string;
  journey?: string;
  action?: string;
}

export enum TrackEventResult {
  Success = 'success',
  Failed = 'failed',
}
